// extracted by mini-css-extract-plugin
export var container = "_qh-0";
export var dotAnimation = "_qh-2";
export var dotsLoading = "_qh-1";